import { MdAppBlocking, MdDashboard } from "react-icons/md";
import { FaFlag, FaUsers } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { Link, useLocation } from 'react-router-dom';
import { MdOutlineCampaign } from "react-icons/md";
import { MdSms } from "react-icons/md";
import { MdOutlineMailLock } from "react-icons/md";
import { MdCampaign } from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { TbWorldCheck } from "react-icons/tb";
import { AiFillDollarCircle } from "react-icons/ai";
import { Accordion } from 'react-bootstrap';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { useState } from "react";
import { FaCircle } from "react-icons/fa";
import { IoFlag } from "react-icons/io5";

function Sidenav() {
  const location = useLocation();
  // const [reportsDropdown, setReportsDropdown] = useState("0");
  const [isReportsOpen, setIsReportsOpen] = useState(false);

  const toggleReportsDropdown = () => {
    setIsReportsOpen(prevState => {
      return !prevState;
    });
  };

  const isActive = (paths: string[]) => {
    return paths.some(path => {
      // Check for exact matches first
      if (location.pathname === path) return true;
      // Check if the current path starts with any of the specified paths
      return location.pathname.startsWith(path) && path !== '/';
    }) ? 'active' : '';
  };

  return (
    <div className="sidebar-dark-primary">
      <aside className="main-sidebar sidebar-dark-primary elevation-1">
        <Link to="/admin/dashboard" className="brand-link">
          <img src={process.env.REACT_APP_BASE_PATH + "/dist/img/AdminLTELogo.png"} alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
          <span className="brand-text font-weight-light">Admin Panel</span>
        </Link>

        <div className="sidebar">
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              <li className="nav-item">
                <Link to="/admin/dashboard" className={`nav-link d-flex align-items-center ${isActive(['/admin/dashboard'])}`}>
                  <MdDashboard className='nav-icon' />
                  <p>Dashboard</p>
                </Link>
              </li>

              {/* Users Menu */}
              <li className="nav-item">
                <Link to="/admin/users" className={`nav-link d-flex align-items-center ${isActive(['/admin/users', '/admin/users/add', '/admin/users/update', '/admin/users/view'])}`}>
                  <FaUsers className='nav-icon' />
                  <p>Users</p>
                </Link>
              </li>

              {/* SMS Gateways */}
              <li className="nav-item">
                <Link to="/admin/smsgateways" className={`nav-link d-flex align-items-center ${isActive(['/admin/smsgateways', '/admin/smsgateways/add', '/admin/smsgateways/update', '/admin/smsgateways/view'])}`}>
                  <MdSms className='nav-icon' />
                  <p>SMS Gateways</p>
                </Link>
              </li>

              {/* SMS-Campaigns */}
              <li className="nav-item">
                <Link to="/admin/sms-campaigns" className={`nav-link d-flex align-items-center ${isActive(['/admin/sms-campaigns', '/admin/sms-campaigns/update', '/admin/sms-campaigns/view', '/admin/view-sms-gateway/details', '/admin/view-sms-gateway/', '/admin/view-sms-gateway/list', '/admin/view-sms-gateway/', 'admin/view-sms-gateway/shortcuts'])}`}>
                  <MdCampaign className='nav-icon' style={{ fontSize: '23px' }} />
                  <p>SMS Campaigns</p>
                </Link>
              </li>

              {/* SMTP Gateways */}
              <li className="nav-item">
                <Link to="/admin/smtp-gateways" className={`nav-link d-flex align-items-center ${isActive(['/admin/smtp-gateways', '/admin/smtp-gateways/add', '/admin/smtp-gateways/view', '/admin/smtp-gateways/update'])}`}>
                  <MdOutlineMailLock className='nav-icon' />
                  <p>SMTP Gateways</p>
                </Link>
              </li>

              {/* SMTP Campaign */}
              <li className="nav-item">
                <Link to="/admin/smtp-campaigns" className={`nav-link d-flex align-items-center ${isActive(['/admin/smtp-campaigns'])}`}>
                  <MdOutlineCampaign className='nav-icon' style={{ fontSize: '23px' }} />
                  <p>SMTP Campaigns</p>
                </Link>
              </li>

              {/* Allow IP */}
              <li className="nav-item">
                <Link to="/allowip" className={`nav-link d-flex align-items-center ${isActive(['/allowip'])}`}>
                  <TbWorldCheck className='nav-icon' />
                  <p>Allow IP</p>
                </Link>
              </li>

              {/* Check Balance */}
              <li className="nav-item">
                <Link to="/admin/check-balance" className={`nav-link d-flex align-items-center ${isActive(['/admin/check-balance'])}`}>
                  <AiFillDollarCircle className='nav-icon' />
                  <p>Check Balance</p>
                </Link>
              </li>

              {/* Flag-ketword */}
              <li className="nav-item">
                <Link to="/admin/flag-keyword" className={`nav-link d-flex align-items-center ${isActive(['/admin/flag-keyword'])}`}>
                  <IoFlag className='nav-icon' />
                  <p>Flag Keyword</p>
                </Link>
              </li>


              {/* Block-List */}
              <li className="nav-item">
                <Link to="/admin/block-list" className={`nav-link d-flex align-items-center ${isActive(['/admin/block-list'])}`}>
                  <MdAppBlocking className='nav-icon' />
                  <p>Block List</p>
                </Link>
              </li>

              {/* Reports Section */}
              <li className='nav-item'>
                <div
                  className={`nav-link d-flex align-items-center flex-nowrap ${isActive(['/admin/sms-campaign-reports/list', '/admin/smtp-campaign-reports/list', '/admin/sms-campaign-reports/:id', '/admin/smtp-campaign-reports/:id', '/admin/sms-campaign-wise-reports/list', '/admin/duplicate-numbers-reports', '/admin/user-logs-reports', '/admin/reports4', '/admin/reports5', '/admin/reports6', '/admin/one-to-one-report/campaign', '/admin/one-to-one-report/', '/admin/custom/report'])}`}
                  onClick={toggleReportsDropdown}
                  style={{ cursor: 'pointer', color: '#C2C7D0' }}
                >
                  <TbReportAnalytics className='nav-icon' />
                  <p className="d-flex justify-content-between flex-grow-1 align-items-center">
                    <span>Reports</span>
                    {isReportsOpen ? <IoIosArrowDown /> : <IoIosArrowBack />}
                  </p>
                </div>

                {/* Submenu with conditional render and transition */}
                <ul className={`nav nav-treeview ${isReportsOpen ? 'open' : 'close'}`}>
                  <li className="nav-item">
                    <Link
                      to="/admin/sms-campaign-reports/list"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/sms-campaign-reports/list', '/admin/sms-campaign-reports', '/admin/sms-campaign-reports/:id'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>SMS Campaign Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/smtp-campaign-reports/list"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/smtp-campaign-reports/list', '/admin/smtp-campaign-reports'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>SMTP Campaign Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/sms-campaign-wise-reports/list"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/sms-campaign-wise-reports/list'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>SMS Campaign Wise Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/duplicate-numbers-reports"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/duplicate-numbers-reports'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>Duplicate Numbers Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/user-logs-reports"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/user-logs-reports'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>User Logs Reports</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/one-to-one-report/campaign"
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/one-to-one-report/campaign', '/admin/one-to-one-report/'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>One To One Report</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to='/admin/custom/report'
                      className={`nav-link d-flex align-items-center ${isActive(['/admin/custom/report'])}`}
                    >
                      <FaCircle className="nav-icon" style={{ fontSize: 10 }} />
                      <p>Custom Report</p>
                    </Link>
                  </li>
                </ul>
              </li>


              {/* Change Password */}
              <li className="nav-item">
                <Link to="/admin/change-password" className={`nav-link d-flex align-items-center ${isActive(['/admin/change-password'])}`}>
                  <RiLockPasswordFill className='nav-icon' />
                  <p className="text-nowrap">Change Password</p>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside >
    </div >
  );
}

export default Sidenav;
